import React from "react";
import StripeConnectProvider from "@/components/StripeConnectProvider";
import { ConnectAccountOnboarding } from "@stripe/react-connect-js";

export default function StripeConnectOnboarding({ publishableKey, onExit }) {
  return (
    <div data-testid="stripe-embedded-onboarding" className="min-h-[400px]">
      <StripeConnectProvider publishableKey={publishableKey}>
        <ConnectAccountOnboarding
          onExit={onExit}
          collectionOptions={{ fields: "currently_due", futureRequirements: "include" }}
        />
      </StripeConnectProvider>
    </div>
  );
}
